module.exports = __webpack_public_path__ + "img/TH.5fd4b8d5.png";